import { useEffect } from 'react';

export default function useActiveCampaignForm({ formId, disabled }) {
  useEffect(() => {
    if (disabled) return;

    const loadScript = () => {
      const script = document.createElement('script');
      script.src = `https://dealfront.activehosted.com/f/embed.php?id=${formId}`;
      script.defer = true;

      document.querySelector('.active-campaign-form').appendChild(script);
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadScript, { timeout: 2000 });
    } else {
      setTimeout(loadScript, 100);
    }

    return () => {
      const existingScript = document.querySelector(
        '.active-campaign-form script'
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [disabled, formId]);
}
